import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../utils/api';
import { Tag } from '../types';

export const useCreateTag = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (name: string): Promise<Tag> =>
      api('/tags', { method: 'POST', body: { name } }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tags'] }),
  });
};

export const useUpdateTag = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, name }: { id: string; name: string }): Promise<Tag> =>
      api(`/tags/${id}`, { method: 'PATCH', body: { name } }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tags'] }),
  });
};

export const useDeleteTag = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string): Promise<{ message: string }> =>
      api(`/tags/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tags'] }),
  });
};
